import { ScmType } from "@protos/common/v1/common";

export const formatGitProvider = (origin: ScmType | undefined) => {
  switch (origin) {
    case ScmType.GITHUB:
    case ScmType.GITHUB_ENTERPRISE:
      return "GitHub";
    case ScmType.GITLAB:
    case ScmType.GITLAB_SELFMANAGED:
      return "GitLab";
    case ScmType.BITBUCKET:
    case ScmType.BITBUCKET_DATACENTER:
      return "Bitbucket";
    case ScmType.AZURE_DEVOPS:
      return "Azure DevOps";
    default:
      return undefined;
  }
};
